import { render, staticRenderFns } from "./mobile-button.vue?vue&type=template&id=f26272ec&scoped=true&"
import script from "./mobile-button.vue?vue&type=script&lang=js&"
export * from "./mobile-button.vue?vue&type=script&lang=js&"
import style0 from "./buttons.scss?vue&type=style&index=0&id=f26272ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26272ec",
  null
  
)

export default component.exports